const dgraph = {
  title: "Software Engineer Intern",
  company: "DGraph Labs",
  period: "August 2023 - November 2023",
  description: "Worked on optimizing DGraph database."
};

export default dgraph;
